// import axios from 'axios';
import * as Yup from 'yup';
import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';
import * as Cookie from '../util-lib/cookie';

export async function getHeaderImage(params = getHeaderImage.__definedParams) {
  params = ensureParams(params, getHeaderImage.__definedParams);
  const api = '/api/v1/destinations/image';
  const data = await apiProxy.get(api, { params });
  return data;
}

getHeaderImage.__definedParams = {
  cityId: '0',
  regionId: '0'
};

// 获取目的地列表
export async function getRegionsList(params = getRegionsList.__definedParams) {
  params = ensureParams(params, getRegionsList.__definedParams);
  const api = 'api/v1.5/TantuTravel/Destination/RegionLists';
  const data = await apiProxy.post(api, params);
  return data['poi_group__destination.RegionLists1_5'].data;
}

getRegionsList.__definedParams = {
  lat: '',
  lng: '',
  filter: 0,
  lang: Cookie.get('lang') || ''
};

// 搜索地区
export async function searchRegions(params = searchRegions.__definedParams) {
  params = ensureParams(params, searchRegions.__definedParams);
  const api = 'api/v1.4/TantuTravel/Search/Destination/DestQuery';
  const data = await apiProxy.post(api, params);
  return data.middleware_group__search_destination_query1.data;
}

searchRegions.__definedParams = {
  keyword: '',
  size: 10,
  ext: ''
};

// 根据经纬度获取国家城市
export async function getLocationInfoByLngAndLat(params = {}) {
  params = ensureParams(params, getLocationInfoByLngAndLat.__definedParams);
  const api = 'api/v1.0/Poi/Tools/Gps';
  const dataSchema = Yup.object({
    gps: Yup.object()
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.gps.data;
}

getLocationInfoByLngAndLat.__definedParams = {
  lng: '',
  lat: ''
};

export async function getDestinationByLocation(params = {}) {
  params = ensureParams(params, getDestinationByLocation.__definedParams);
  const api = 'api/v2.0/Poi/Destinations/Location';
  const dataSchema = Yup.object({
    getDestinationsLocationV2: Yup.object()
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getDestinationsLocationV2.data;
}

getDestinationByLocation.__definedParams = {
  destinationType: 'none',
  destinationId: '0',
  locationType: 'none',
  locationId: '0',
  previousLocationType: 'none',
  previousLocationId: '0',
  zzcDestinationType: 'none',
  zzcDestinationId: '0',
  poiDestinationType: 'none',
  poiDestinationId: '0',
  previousLocationTime: 0
};

export async function getDestinationRecommend(params = {}) {
  params = ensureParams(params, getDestinationRecommend.__definedParams);
  const api = 'api/v1.0/Poi/Destinations/Recommend';
  const dataSchema = Yup.object({
    getDestinationsRecommend: Yup.object()
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getDestinationsRecommend.data;
}

getDestinationRecommend.__definedParams = {
  destinationType: '',
  destinationId: '',
  ruleId: '',
  preview: '0'
};

export async function getDestinationImage(params = {}) {
  params = ensureParams(params, getDestinationImage.__definedParams);
  const api = 'api/v1.0/Poi/Destinations/Info';
  const dataSchema = Yup.object({
    getDestinationsInfo: Yup.object()
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.getDestinationsInfo.data;
}

getDestinationImage.__definedParams = {
  destinationType: '',
  destinationId: ''
};

export async function getDestinationRuleId(params = {}) {
  params = ensureParams(params, getDestinationRuleId.__definedParams);
  const api = 'api/v1.0/Poi/Cms/Rule/Query';
  const dataSchema = Yup.object({
    findRuleByDestination: Yup.object()
  });
  const data = await apiProxy.get(api, { params, dataSchema });
  return data.findRuleByDestination.data;
}

getDestinationRuleId.__definedParams = {
  destinationType: '',
  destinationId: ''
};

export async function getAreaList() {
  const api = 'api/v1.0/Poi/Destinations/AreaList';
  const dataSchema = Yup.object({
    destinationsAreaList: Yup.object()
  });
  const data = await apiProxy.get(api, { params: {}, dataSchema });
  return data.destinationsAreaList.data;
}
